export default "__VITE_ASSET__CylUXl9d__"